export const calcTablePage = (skip: number, take: number): number => {
  return (skip + take) / take;
};
